import { render, staticRenderFns } from "./set-password-dialog.component.vue?vue&type=template&id=d171d138"
import script from "./set-password-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./set-password-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d171d138')) {
      api.createRecord('d171d138', component.options)
    } else {
      api.reload('d171d138', component.options)
    }
    module.hot.accept("./set-password-dialog.component.vue?vue&type=template&id=d171d138", function () {
      api.rerender('d171d138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-setup/set-password-dialog/set-password-dialog.component.vue"
export default component.exports